var React = require('react');

function Time (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M7.99992 14.6666C4.31792 14.6666 1.33325 11.682 1.33325 7.99998C1.33325 4.31798 4.31792 1.33331 7.99992 1.33331C11.6819 1.33331 14.6666 4.31798 14.6666 7.99998C14.6666 11.682 11.6819 14.6666 7.99992 14.6666ZM8.66659 7.99998V4.66665H7.33325V9.33331H11.3333V7.99998H8.66659Z","fill":"#D48D00"}));
}

Time.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = Time;

Time.default = Time;
